import {
  IDeltaHedgeExeCommonSearchParam,
  IInsReport,
} from "../../Interfaces/deltaHedgeExe";
import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getInsTable } from "../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const InsTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IInsReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getInsTable}
      searchParameters={searchParams}
    />
  );
};
export default InsTable;
